import axios from "../../axios"

export const getreport = async (accountId) => {
    try {
        const resp = await axios.post(`/internal/api/report/download-report-list`);
        return resp.data
    } catch (error) {
        throw error
    }
}